export default "__VITE_ASSET__Ctc9aTIq__"